import config from 'config';
import utils from '../mixins/utils';

const { getAuthZToken, setAuthZToken } = utils.methods;
const rejectCodes = [400, 404, 403, 401, 500, 422];

function getBaseUrl() {
  const requestUrl = config.apiRequestUrl || config.apiUrl;
  if (requestUrl.startsWith('/')) {
    return window.location.origin + requestUrl;
  }
  return requestUrl;
}

function buildHeaders(customHeaders, body, form) {
  const headers = { ...(customHeaders || {}) };
  const token = getAuthZToken();

  if (!headers.Authorization && token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  if (form && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/x-www-form-urlencoded';
  }

  return headers;
}

function encodeFormData(form) {
  return Object.keys(form)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(form[key])}`)
    .join('&');
}

function apiCaller(endpoint, method, body, form, headers, fullResponse) {
  const url = getBaseUrl() + endpoint;
  const requestMethod = method || 'GET';
  const requestHeaders = buildHeaders(headers, body, form);

  const options = {
    method: requestMethod,
    headers: requestHeaders
  };

  if (body) {
    options.body = JSON.stringify(body);
  } else if (form) {
    options.body = encodeFormData(form);
  }

  return fetch(url, options).then(async (response) => {
    const token = response.headers.get('token');
    if (token) {
      setAuthZToken(token);
    }

    let responseBody = null;
    const contentType = response.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {
      responseBody = await response.json();
    } else {
      const text = await response.text();
      responseBody = text || null;
    }

    const legacyResponse = {
      statusCode: response.status,
      body: responseBody,
      headers: response.headers
    };

    if (rejectCodes.includes(response.status)) {
      return Promise.reject([response.status, responseBody]);
    }

    if (fullResponse) {
      return legacyResponse;
    }

    return responseBody;
  }).catch((error) => {
    if (Array.isArray(error)) {
      return Promise.reject(error);
    }

    return Promise.reject([0, error.message || 'Network request failed']);
  });
}

export default apiCaller;
